import { render, staticRenderFns } from "./userGrowthRecordIndex.vue?vue&type=template&id=0b837915&scoped=true&"
import script from "./userGrowthRecordIndex.vue?vue&type=script&lang=ts&"
export * from "./userGrowthRecordIndex.vue?vue&type=script&lang=ts&"
import style0 from "./userGrowthRecordIndex.vue?vue&type=style&index=0&id=0b837915&scoped=true&lang=scss&"
import style1 from "./userGrowthRecordIndex.vue?vue&type=style&index=1&id=0b837915&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b837915",
  null
  
)

export default component.exports